import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "sprite-grid-container"
};
const _hoisted_2 = {
  class: "sprite-grid"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "icon-wrapper"
};
const _hoisted_5 = ["width", "height"];
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  key: 0,
  class: "pagination-container"
};
import { ref, computed, watch, nextTick, onBeforeUpdate } from 'vue';
import { loadSpriteSheet, drawIcon } from '@/tools/mapImageTool';
import { ElPagination } from "element-plus";
import store from "@/store"; // pre-declaration

export default {
  __name: 'SpriteGridView',
  props: {
    jsonPath: {
      type: String,
      required: true
    },
    spriteImagePath: {
      type: String,
      required: true
    },
    cellSize: {
      type: Number,
      default: 100
    }
  },
  emits: ['select'],

  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const size = ref(40);
    const pagerCount = ref(5);
    const page = ref(0);
    const allSprites = ref([]);
    const selectedName = ref('');
    const canvasRefs = ref([]); // computed

    const cachedImages = computed(() => store.state.map_images);
    const total = computed(() => allSprites.value.length);
    const paginatedSprites = computed(() => {
      const start = page.value * size.value;
      const end = start + size.value;
      return allSprites.value.slice(start, end);
    }); // functions

    const setCanvasRef = (el, index) => {
      if (el) canvasRefs.value[index] = el;
    };

    const loadData = async () => {
      allSprites.value = require(`@/assets/sprite/${props.jsonPath}`);
      await loadSpriteSheet(props.spriteImagePath);
      await drawVisibleIcons();
    };

    const drawVisibleIcons = async () => {
      await nextTick();
      if (!Object.keys(cachedImages.value).includes(props.spriteImagePath)) return; // console.log(`drawVisibleIcons ${paginatedSprites.value.length}`)

      paginatedSprites.value.forEach((sprite, index) => {
        const canvas = canvasRefs.value[index];
        if (!canvas) return;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, props.cellSize, props.cellSize);
        const scale = Math.min(props.cellSize / sprite.width, props.cellSize / sprite.height) * 0.9;
        const offsetX = (props.cellSize - sprite.width * scale) / 2;
        const offsetY = (props.cellSize - sprite.height * scale) / 2;
        drawIcon(ctx, cachedImages.value[props.spriteImagePath], sprite.x, sprite.y, sprite.width, sprite.height, offsetX, offsetY, scale);
      });
    };

    const handlePageChange = index => {
      page.value = index - 1;
      drawVisibleIcons();
    };

    const handleSelect = sprite => {
      selectedName.value = sprite.name;
      emits('select', {
        x: sprite.x,
        y: sprite.y,
        width: sprite.width,
        height: sprite.height,
        imagePath: props.spriteImagePath
      });
    };

    const cancelSelect = () => {
      selectedName.value = '';
    }; // lifecycle


    onBeforeUpdate(() => canvasRefs.value = []); // watcher

    watch(() => props.spriteImagePath, () => {
      loadData();
    }, {
      immediate: true
    }); // post-declaration

    __expose({
      cancelSelect
    });

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedSprites.value, (sprite, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: sprite.name,
          class: _normalizeClass(["grid-item", {
            active: selectedName.value === sprite.name
          }]),
          onClick: $event => handleSelect(sprite)
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("canvas", {
          ref_for: true,
          ref: el => setCanvasRef(el, index),
          width: __props.cellSize,
          height: __props.cellSize
        }, null, 8, _hoisted_5)]), _createElementVNode("div", {
          class: "sprite-name",
          title: sprite.name
        }, _toDisplayString(sprite.desc), 9, _hoisted_6)], 10, _hoisted_3);
      }), 128))]), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(ElPagination), {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]);
    };
  }

};